import googleFonts from '@/json/googleFonts'

export default function (theme, fontContainer) {
  const base = theme.general.fontFamily
  const fontList = []

  fontContainer[base] = new Set([ ...fontContainer[base], ...fontContainer.inherit ])
  delete fontContainer.inherit

  Object.entries(fontContainer).forEach(([ key, vs ]) => {
    if (!googleFonts[key]) return

    const variants = [ ...vs ]
    const vsx = variants.map(v => {
      if (v === 'regular') return '400'
      if (v === 'italic') return '400i'

      return v.replace('italic', 'i')
    }).filter(v => v !== 'inherit').join(',')

    fontList.push(encodeURIComponent(key) + ':' + vsx)
  })

  return fontList.join('|') || ''
}
